
import '../App.css';
import firebase from 'firebase/compat/app';
import React, { useState, useEffect, useRef } from 'react';
import logo from '../assets/logo.png'
import { useNavigate } from 'react-router-dom';
import { db, firestore, storage } from '../config';
import moment from 'moment/moment';
import { FaUserFriends } from "react-icons/fa";
import { FaUserTie } from "react-icons/fa";
//import 'react-toastify/dist/ReactToastify.css';
import ReactModal from 'react-modal';
import { toast } from 'wc-toast'
import { RxCross2, RxExternalLink } from "react-icons/rx";
import { active_activityplan_icon, active_goal_icon, active_habit_icon, active_journal_icon, active_vision_icon, active_week_plan_icon, active_win_icon, activities_dashboard_icon, inactive_activityplan_icon, inactive_dashboard_icon, inactive_goal_icon, inactive_habit_icon, inactive_journal_icon, inactive_video_icon, inactive_vision_icon, inactive_week_plan_icon, inactive_win_icon, invite_inactive, logout_icon, settings_inactive } from '../assets/Icon';
import ReactiveButton from 'reactive-button';
import { RxCross1 } from "react-icons/rx";
//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';
import { FaRegEdit } from "react-icons/fa";
import { RiDeleteBinLine } from "react-icons/ri";
import ToggleButton from 'react-toggle-button'
import { FiPlus } from "react-icons/fi";
import '../App.css';
import Calendar from 'react-calendar';
import { MdChevronRight, MdDeleteOutline } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import { FaCheckCircle } from "react-icons/fa";
import { IoMdCheckmarkCircle } from "react-icons/io";
import { connect } from 'react-redux';
import { SetId, SwitchMode } from './redux/actions';
import { decrypt, encrypt } from '../Crypto';
import Select, { components } from 'react-select';
import { RiArrowDropDownLine } from "react-icons/ri";
import { RiArrowDropUpLine } from "react-icons/ri";
import { VscThreeBars } from 'react-icons/vsc';
import Popup from 'reactjs-popup';
import Modal from 'react-responsive-modal';
const inactive_color = '#cbb6fe'

const out_link = <RxExternalLink size={24} color='black' />

const habitdb = db.ref('habitdb');
const habits = db.ref('habit');

const candidate_db = firestore.collection('candidate_db')

const userdb = db.ref('userdb');


const recruiter_active = <FaUserTie color='white' size={22} />
const recruiter_active_non = <FaUserTie color='#B9B9B9' size={22} />

const weeks = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']

const search_icons = <RiArrowDropDownLine color='white' size={25} />
const search_icon_another = <RiArrowDropUpLine color='white' size={25} />


function Habit({ items, SetId, SwitchMode }) {

    let curr = new Date().getTime();

    useEffect(() => {
        if (items.myid == null) {
            let obj = localStorage.getItem('login')
            if (obj != null) obj = JSON.parse(obj)
            SetId(obj)
        }
    }, [])

    useEffect(() => {
        console.log('Items', items)
        if (items.myid != null && (items.logout || items.myid.sub_id == undefined) && items.trial == 0) {

            navigate('/')
        }
    }, [items])

    const dot = (color = 'transparent') => ({
        alignItems: 'center',
        display: 'flex',
        color: 'white', fontWeight: '400', fontSize: 16, backgroundColor: '#292e33', height: 50,
        borderTopLeftRadius: 4, borderBottomLeftRadius: 4, paddingLeft: 5, fontFamily: 'Barlow Condensed'
    });

    const dot1 = (color = 'transparent') => ({
        alignItems: 'center',
        display: 'flex',
        color: 'white', fontWeight: '400', fontSize: 16,
        backgroundColor: '#292e33',
        textAlign: 'left',
        width: '100%', fontFamily: 'Barlow Condensed'
    });

    const dot2 = (color = 'transparent') => ({
        alignItems: 'center',
        display: 'flex',
        color: '#292e33', fontWeight: '400', fontSize: 16,
        backgroundColor: 'white',
        textAlign: 'left',
        width: '100%',
        height: 300,
        flexDirection: 'column',
        borderRadius: 4, fontFamily: 'Barlow Condensed'
    });

    const [width, setWidth] = useState(window.innerWidth);
    const [height, setHeight] = useState(Math.max(window.innerHeight, 1200));

    useEffect(() => {
        const windowSizeHandler = () => {
            setWidth(window.innerWidth)
            setHeight(Math.max(window.innerHeight, 1200))
        };
        window.addEventListener("resize", windowSizeHandler);

        return () => {
            window.removeEventListener("resize", windowSizeHandler);
        };
    }, []);

    const navigate = useNavigate();

    const [touched1, setTouched1] = useState(false);


    function toggleTouched1() {
        setTouched1(!touched1);
    }

    function handleMouseUp1() {
        // Handle smooth animation when clicking without holding
        setTimeout(() => {
            setTouched1(!touched1);
        }, 150);
    }

    const [date, setDate] = useState(new Date())


    const [myjournals, setMyJournals] = useState([])


    const [start, setStart] = useState(null)
    const [end, setEnd] = useState(null)

    const [myrecords, setRecords] = useState([])

    useEffect(() => {
        if (start != null && end != null && items.myid != null) {
            const journal_db = firestore.collection(`habit`)
            const unsubscribe = journal_db.where('day_id', '>=', start).where('day_id', '<=', end).where('user_id', '==', items.myid.ID).onSnapshot(snapshot => {
                // console.log('Dats ',snapshot.docs[0].data())
                let arr = snapshot.docs
                for (let i = 0; i < arr.length; i++) {
                    arr[i] = arr[i].data()
                }
                console.log('Arr ', arr);

                arr.sort(function (a, b) { return b.ID - a.ID });
                if (arr.length > 0) setRecords([...arr])
                else setRecords([])
            })
            return () => unsubscribe()
        }
    }, [start, end, items.myid])

    function select_date(day) {


        const time = new Date().getTime()
        console.log('Select day ', new Date(day).getDay())

        let dues = new Date(day);
        if (new Date(day).getDay() == 0) {
            dues = new Date(moment(new Date(dues)).subtract(6, 'days'))
        }
        dues.setMilliseconds(0)
        dues.setHours(0)
        dues.setSeconds(0)
        dues.setMinutes(0)
        let start = dues, end = dues;

        let curr = dues.getDay()
        let left = curr;
        let right = 6 - curr;

        start = moment(new Date(dues)).subtract(left, 'days')
        end = moment(new Date(dues)).add(right + 1, 'days')

        setStart(new Date(start).getTime())
        setEnd(new Date(end).getTime())

    }

    useEffect(() => {
        select_date(new Date().getTime())
    }, [])



    function timing(day) {
        let new_mom = moment(new Date(day)).add(1, 'days')
        let res = new Date(new_mom).getDate() + " " + months[new Date(Number(new_mom)).getMonth()] + ", " + moment(new Date(Number(new_mom))).format('YYYY')
        return res.toLocaleUpperCase();
    }

    const weekly = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']


    const DropdownIndicator = props => {
        if (props.isFocused) return (
            components.DropdownIndicator && (
                <components.DropdownIndicator {...props}>
                    <div style={{ height: 50, width: 30, borderRadius: 4, alignItems: 'center', justifyContent: 'center', display: 'flex', zIndex: 100, marginLeft: -20, backgroundColor: '#292e33' }}>
                        {search_icon_another}
                    </div>
                </components.DropdownIndicator>
            )
        );
        else return (
            components.DropdownIndicator && (
                <components.DropdownIndicator {...props}>
                    <div style={{ height: 50, width: 30, borderRadius: 4, alignItems: 'center', justifyContent: 'center', display: 'flex', zIndex: 100, marginLeft: -20, backgroundColor: '#292e33' }}>

                        {search_icons}
                    </div>
                </components.DropdownIndicator>
            )
        );
    };

    const [curr_habit_id, setCurrHabit] = useState(null)
    const [habit_text, setHabitText] = useState('')
    const [myhabits, setMyhabits] = useState([])
    const [obj, setObj] = useState({ id: -1, jobid: -1 })

    function getDayid(day) {
        let new_moment = moment(new Date(start)).add(day, 'days')
        new_moment = new Date(new_moment).getTime()
        return new_moment;
    }

    function isContain(arr) {

        for (let i = 0; i < arr.length; i++) {

            if (arr[i].data().streak == 0) return true;
        }
        return false;
    }

    function getMax(val, jobid) {
        let today = new Date();
        let ans = val;
        let diff = 100;
        for (let i = 0; i < myhabits.length; i++) {
            if (myhabits[i].last_streak != undefined) diff = moment(today).diff(new Date(myhabits[i].last_streak), 'hours')
            else diff = 100
            if (myhabits[i].ID != jobid && diff <= 24) ans = Math.max(ans, myhabits[i].streak == undefined ? 0 : myhabits[i].streak)
        }
        return ans;
    }


    async function positiveUpdate() {

        toast('Please wait')

        let new_moment = moment(new Date(start)).add(obj.id, 'days')
        new_moment = new Date(new_moment).getTime()

        let immediate_back = moment(new Date(new_moment)).subtract(1, 'days')
        immediate_back = new Date(immediate_back).getTime()

        let today = new Date()

        // one day back data 
        const journal_db = firestore.collection(`habit`)
        let datas = await journal_db.where('day_id', '<', new_moment).where('day_id', '>=', immediate_back).where('user_id', '==', items.myid.ID).where('jobid', '==', obj.jobid).orderBy('day_id').limitToLast(1).get()
        datas = datas.docs


        let nexts = await journal_db.where('day_id', '>', new_moment).where('user_id', '==', items.myid.ID).where('jobid', '==', obj.jobid).get()
        nexts = nexts.docs


        console.log('Next ', nexts.length)
        console.log('prev ', datas.length > 0 ? datas[0].data() : 0)

        const goal_db = firestore.collection(`habit`)
        const ID = new Date().getTime()
        let check = await journal_db.where('day_id', '==', new_moment).where('user_id', '==', items.myid.ID).where('jobid', '==', obj.jobid).get()
        let objj, streak = 0;


        // this the last one or middlle new one  , need calculate with previous 
        if (check.empty && nexts.length == 0) {
            objj = {
                ID: ID,
                day_id: new_moment,
                text: 'positive',
                jobid: obj.jobid,
                user_id: items.myid.ID,
                streak: datas.length == 0 ? 1 : datas[0].data().streak + 1
            }
            let diff = moment(today).diff(new Date(new_moment), 'hours')
            // today ticking on 
            if (diff <= 24) streak = datas.length == 0 ? 1 : datas[0].data().streak + 1
            await habitdb.child(String(items.myid.ID)).child(String(obj.jobid)).update({ streak: streak, last_streak: new Date().getTime() })
            if (diff <= 24) await userdb.child(String(items.myid.ID)).update({ streak: getMax(streak, obj.jobid), last_streak: new Date().getTime() })
        }

        /// if it is middle one day , need to update next all dats to this one 
        else {
            let exist_id = check.docs
            if (!check.empty) exist_id = exist_id[0].data().ID

            objj = {
                ID: check.empty ? ID : exist_id,
                day_id: new_moment,
                text: 'positive',
                jobid: obj.jobid,
                user_id: items.myid.ID,
                streak: datas.length == 0 ? 1 : datas[0].data().streak + 1
            }

            /// we need to update all nexts

            let i = 0;
            let diff = 0;
            for (i = 0; i < nexts.length; i++) {
                diff = 0;
                if (i > 0) {
                    diff = moment(new Date(Number(nexts[i].data().day_id))).diff(new Date(Number(nexts[i - 1].data().day_id)), 'hours')
                }
                else diff = moment(new Date(Number(nexts[i].data().day_id))).diff(new Date(Number(new_moment)), 'hours')
                // increase all by one 
                console.log('Updating one ', diff)
                if (nexts[i].data().streak != 0 && diff <= 24) {
                    await goal_db.doc(String(nexts[i].data().ID)).update({ streak: nexts[i].data().streak + objj.streak })
                }
                else { break; }
            }

            if (i > 0) diff = moment(new Date(Number(today))).diff(new Date(Number(nexts[i - 1].data().day_id)), 'hours')
            else diff = moment(today).diff(new Date(new_moment), 'hours')

            // current habit streak , if last one is up to date ,today we can update only streak;
            if (nexts.length > 0 && !isContain(nexts) && i == nexts.length && diff <= 24) {
                await habitdb.child(String(items.myid.ID)).child(String(obj.jobid)).update({ streak: nexts[i - 1].data().streak + objj.streak, last_streak: new Date().getTime() })
                await userdb.child(String(items.myid.ID)).update({ streak: getMax(nexts[i - 1].data().streak + objj.streak, obj.jobid), last_streak: new Date().getTime() })
            }

            // current date
            else if (diff <= 24) {
                await habitdb.child(String(items.myid.ID)).child(String(obj.jobid)).update({ streak: objj.streak, last_streak: new Date().getTime() })
                await userdb.child(String(items.myid.ID)).update({ streak: getMax(objj.streak, obj.jobid), last_streak: new Date().getTime() })
            }

        }

        await goal_db.doc(String(objj.ID)).set(objj)
        setObj({ ...obj, id: -1, jobid: -1 })
        toast('Your data has been saved')
    }

    function getResponse(jobid, day) {
        let new_moment = moment(new Date(start)).add(day, 'days')
        new_moment = new Date(new_moment).getTime()
        for (let i = 0; i < myrecords.length; i++) {
            if (myrecords[i].day_id == new_moment && myrecords[i].jobid == jobid) {
                return myrecords[i].text
            }
        }
        return null;
    }

    function getDateBox(day) {
        let new_moment = moment(new Date(start)).add(day, 'days')
        new_moment = new Date(new_moment).getTime()
        let curr_dat = new Date().getTime()
        return new_moment <=curr_dat;
    }

    async function negativeUpdate() {

        toast('Please wait')
        let new_moment = moment(new Date(start)).add(obj.id, 'days')
        new_moment = new Date(new_moment).getTime()
        const goal_db = firestore.collection(`habit`)
        const ID = new Date().getTime()

        let immediate_back = moment(new Date(new_moment)).subtract(1, 'days')
        immediate_back = new Date(immediate_back).getTime()

        let today = new Date()

        let check = await goal_db.where('day_id', '==', new_moment).where('user_id', '==', items.myid.ID).where('jobid', '==', obj.jobid).get()
        let objj;
        let diff = 0;

        let nexts = await goal_db.where('day_id', '>', new_moment).where('user_id', '==', items.myid.ID).where('jobid', '==', obj.jobid).get()
        nexts = nexts.docs
        let prom = []


        // new one created
        if (check.empty && nexts.length == 0) {

            objj = {
                ID: ID,
                day_id: new_moment,
                text: 'negative',
                jobid: obj.jobid,
                user_id: items.myid.ID,
                streak: 0
            }
            let diff = moment(today).diff(new Date(new_moment), 'hours')
            console.log('Single hour ', diff)
            if (diff <= 24) {
                await habitdb.child(String(items.myid.ID)).child(String(obj.jobid)).update({ streak: 0, last_streak: new Date().getTime() });
                await userdb.child(String(items.myid.ID)).update({ streak: getMax(0, obj.jobid), last_streak: new Date().getTime() })
            }

        }

        // existing one 

        else {

            let exist_id = check.docs
            if (!check.empty) exist_id = exist_id[0].data().ID

            objj = {
                ID: check.empty ? ID : exist_id,
                day_id: new_moment,
                text: 'negative',
                jobid: obj.jobid,
                user_id: items.myid.ID,
                streak: 0
            }

            let i, diff;
            for (i = 0; i < nexts.length; i++) {
                diff = 0;
                if (i > 0) {
                    diff = moment(new Date(Number(nexts[i].data().day_id))).diff(new Date(Number(nexts[i - 1].data().day_id)), 'hours')
                }
                else diff = moment(new Date(Number(nexts[i].data().day_id))).diff(new Date(Number(new_moment)), 'hours')
                if (nexts[i].data().streak != 0 && diff <= 24) { await goal_db.doc(String(nexts[i].data().ID)).update({ streak: i + 1 }) }
                else { break; }
            }
            if (i > 0) diff = moment(new Date(Number(today))).diff(new Date(Number(nexts[i - 1].data().day_id)), 'hours')
            else diff = moment(today).diff(new Date(Number(new_moment)), 'hours')
            console.log('Next ', nexts.length, nexts.length)
            // current habit streak 
            if (nexts.length > 0 && !isContain(nexts) && i == nexts.length && diff <= 24) {
                console.log('Streak now ', getMax(nexts.length, obj.jobid))
                await habitdb.child(String(items.myid.ID)).child(String(obj.jobid)).update({ streak: nexts.length, last_streak: new Date().getTime() })
                await userdb.child(String(items.myid.ID)).update({ streak: getMax(nexts.length, obj.jobid), last_streak: new Date().getTime() })
            }

            // the current day ,negative
            else if (diff <= 24) {
                await habitdb.child(String(items.myid.ID)).child(String(obj.jobid)).update({ streak: 0, last_streak: new Date().getTime() })
                await userdb.child(String(items.myid.ID)).update({ streak: getMax(0, obj.jobid), last_streak: new Date().getTime() })
            }

        }


        await goal_db.doc(String(objj.ID)).set(objj)
        setObj({ ...obj, id: -1, jobid: -1 })
        toast('Your data has been saved')

    }

    useEffect(() => {
        if (items.myid != null) {
            let subscribe = habitdb.child(String(items.myid.ID)).on('value', (snap) => {
                if (snap != undefined) {
                    let arr = snap.val() == null ? [] : Object.values(snap.val())
                    setMyhabits([...arr])
                }
            })
            return () => subscribe()
        }
    }, [items.myid])

    async function addHabit() {
        if (curr_habit_id != null && habit_text != '') {
            await habitdb.child(String(items.myid.ID)).child(String(curr_habit_id)).set({ ID: curr_habit_id, text: encrypt(habit_text) })
            toast('Your data has been added !')
            setHabitText('')
        }
        else {
            toast('Please select pick list or enter text in text box')
        }
    }

    const [habit_all, setHabitAll] = useState([])

    useEffect(() => {
        let subscribe = habits.on('value', (snap) => {
            if (snap != undefined) {
                let arr = snap.val() == null ? [] : Object.values(snap.val())
                for (let i = 0; i < arr.length; i++) {
                    arr[i].label = arr[i].text
                    arr[i].value = arr[i].text
                }
                setHabitAll([...arr])
            }
        })
        return () => subscribe()
    }, [])

    function getName(id) {
        for (let i = 0; i < habit_all.length; i++) {
            if (habit_all[i].id == id) return habit_all[i].text
        }
        return ''
    }

    function make_show(ID, val) {
        let temp = [...myhabits]
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].ID == ID) {
                temp[i].show = val
            }
        }
        setMyhabits([...temp])
    }

    const [picture, setPicture] = useState(null)
    const [imguri, setImgUri] = useState(null)

    const handleDrop = (e) => {
        e.preventDefault()
        console.log('select ', e.target.files[0])
        let file = e.target.files[0]
        let temp = []

        let reader = new FileReader();
        reader.onloadend = () => {
            setPicture(reader.result)
            setImgUri(file)
        }
        reader.readAsDataURL(file);
        //console.log('All temp ', temp)
    }

    const ref = useRef()

    const openFileInput = () => {
        ref.current.click()
    }

    const uploadImage = async (key, imguri) => {
        const upload = storage.ref(`/users/${key}`).put(imguri)
        await Promise.resolve(upload)
        let uri = await storage.ref(`/users/${key}`).getDownloadURL();
        return uri
    };

    async function updateUri() {
        toast('Please wait')
        let id = items.myid.ID
        let uri = await uploadImage(id, imguri)
        await userdb.child(String(id)).update({ uri: uri })
        let obj = items.myid;
        obj.uri = uri;
        SetId(obj)
        toast('Your photo has been uploaded ')
    }

    useEffect(() => {
        if (imguri != null) {
            updateUri()
        }
    }, [imguri])

    const [habit_delete, setHabitDelete] = useState(false)

    async function delete_habit(id) {
        await habitdb.child(String(items.myid.ID)).child(String(id)).remove()
        setHabitDelete(false);
        toast('This habit has been deleted')
    }

    const isMobile = width <= 768;

    const getHeight = Math.max(height, 2300)

    const top_ref = useRef()

    const setting_ref = useRef()

    function show_streak(item) {
        let today = new Date();
        if (item.streak == undefined) return 0;
        else {
            let diff = moment(today).diff(new Date(item.last_streak), 'hours')
            if (diff <= 24) return item.streak
            else return 0;
        }
    }


    return (
        !isMobile ? <div style={{ backgroundColor: '#f3f9eb', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0 }}>
            <div style={{ backgroundColor: '#8455f6', position: 'absolute', top: 0, left: 0, display: 'flex', flexDirection: 'column', height: height, width: 286, textAlign: 'center' }}>
                <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#8455f6", width: 276, height: 100, justifyContent: 'center', alignItems: 'center' }}>
                    <text style={{ color: 'white', marginTop: 30, fontSize: 15, fontFamily: 'Roboto' }}>{items.myid != null&&decrypt(items.myid.first)} {items.myid != null&&decrypt(items.myid.second)}</text>
                </div>

                <div onClick={() => navigate('/Dashboard')} style={{ height: 48, cursor: 'pointer', marginTop: 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 286, padding: 10, alignSelf: 'center', alignItems: 'center' }}>
                    <div style={{ width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 19 }}>{inactive_dashboard_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Dashboard</text>
                    </div>
                </div>


                {!items.mode ? <div onClick={() => navigate('/Vision')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_vision_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My vision</text>
                    </div>
                </div> : null}

                <div onClick={() => navigate('/Goals')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_goal_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My goals</text>
                    </div>
                </div>


                <div onClick={() => navigate('/WeeklyPlan')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_week_plan_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Weekly Action Plan</text>
                    </div>
                </div>


                {!items.mode ? <div onClick={() => navigate('/Journal')} style={{ cursor: 'pointer', height: 48, marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 286, padding: 10, alignSelf: 'center', alignItems: 'center' }}>
                    <div style={{ width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_journal_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Journal</text>
                    </div>
                </div> : null}

                <div onClick={() => navigate('/ActivityPlan')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_activityplan_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Activity Plan</text>
                    </div>
                </div>

                <div onClick={() => navigate('/Wins')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_win_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My Wins</text>
                    </div>
                </div>

                <div onClick={() => navigate('/')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ backgroundColor: '#FFFFFF', flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 19 }}>{active_habit_icon}</div>
                        <text style={{ color: '#8455F6', marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Habit Tracking</text>
                    </div>
                </div>

                <div onClick={() => navigate('/Videos')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{inactive_video_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Videos</text>
                    </div>
                </div>

                <div onClick={() => navigate('/Companies')} style={{ cursor: 'pointer', height: 48, marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{invite_inactive}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Invitations</text>
                    </div>
                </div>

                <div onClick={() => navigate('/Settings')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{settings_inactive}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Settings</text>
                    </div>
                </div>

                <div onClick={() => navigate('/')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                        <div style={{ color: 'white', fontSize: 23 }}>{logout_icon}</div>
                        <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Log Out</text>
                    </div>
                </div>

                <div style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                    <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center', backgroundColor: '#FFFFFF' }}>
                        <text style={{ color: '#8455F6', marginLeft: 20, fontSize: 15, fontFamily: 'Roboto' }}>Coaching Mode</text>
                        <div style={{ width: 45, display: 'flex', marginLeft: 10 }}>
                            <ToggleButton
                                value={items.mode}
                                inactiveLabel={<text></text>}
                                activeLabel={<text></text>}
                                style={{ background_color: '#41A4C3' }}
                                onToggle={(value) => {
                                    SwitchMode()
                                }}
                                colors={{
                                    activeThumb: {
                                        base: 'white',
                                    },
                                    inactiveThumb: {
                                        base: 'black',
                                    },
                                    active: {
                                        base: '#8455f6',
                                        hover: 'rgb(177, 191, 215)',
                                    },
                                    inactive: {
                                        base: 'gray',
                                        hover: 'gray',
                                    }
                                }} />
                        </div>
                    </div>
                </div>

                <img src={logo} style={{ width: 80, height: 80, alignSelf: 'center', marginTop: 20 }} />

            </div>

            <input id="actual" ref={ref} accept="/*" type="file" onChange={handleDrop} onClick={(event) => {
                event.currentTarget.value = null
            }} hidden={true} />

            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 286, width: width - 286, position: 'absolute', top: 0, height: height, backgroundColor: '#1f2327' }}>

                <div style={{ display: 'flex', height: 100, width: width - 286, justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#292e33', boxShadow: '1px 1px 1px 1px #292E33' }}>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'content' }}>
                        <text style={{ marginLeft: 40, fontSize: 40, fontWeight: '600', letterSpacing: 1.01, color: '#8c52ff', textAlign: 'left', fontFamily: 'Barlow Condensed' }}>MY HABIT TRACKING</text>
                    </div>
                    {items.myid != null&&items.myid.uri == undefined && <img onClick={() => openFileInput()} style={{ cursor: 'pointer', width: 60, height: 60, borderRadius: 30, marginRight: 30 }} src={'data:image/png;base64,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'} />}
                    {items.myid != null&&items.myid.uri != undefined && <img onClick={() => openFileInput()} src={items.myid.uri} style={{ cursor: 'pointer', height: 60, width: 60, borderRadius: 30, marginRight: 30 }} />}

                </div>

                <div style={{ marginTop: 50, height: height - 200, width: width - 350, alignSelf: 'center', flexDirection: 'row', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                    <div style={{ height: height - 200, width: '60%', backgroundColor: '#292e33', alignSelf: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center' }}>


                        <div style={{ display: 'flex', width: '96%', alignSelf: 'center', justifyContent: 'left', alignItems: 'center', backgroundColor: '#1F2327', height: 50, marginTop: 10 }}>
                            <text style={{ textAlign: 'left', color: '#8c52ff', fontSize: 26, fontWeight: '500', fontFamily: 'Barlow Condensed', marginLeft: 10 }}>{start == null ? 'SELECT WEEK FROM CALENDAR' : `WEEK STARTING ${timing(start)}`}</text>
                        </div>

                        <div style={{ width: '97%', alignSelf: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 20, overflowY: 'scroll', overflowX: 'hidden' }}>
                            {myhabits.map((item, id) => <div onMouseEnter={() => make_show(item.ID, true)} onMouseLeave={() => make_show(item.ID, false)} style={{ height: 80, width: '97%', flexDirection: 'column', justifyContent: 'left', marginTop: 5 }}>
                                <div style={{ width: '95%', height: 35, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <text style={{ color: '#8c52ff', fontWeight: '500', fontFamily: 'Barlow Condensed', fontSize: 22 }}>{getName(item.ID)} - Streak : {show_streak(item)} days</text>
                                </div>
                                <div style={{ width: '95%', height: 45, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <div style={{ width: '55%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row' }}>
                                        <div onClick={(e) => { if (getDateBox(1)) setObj({ ...obj, id: 1, jobid: item.ID }) }} style={{ opacity: getDateBox(1) ? 1 : 0.7, cursor: 'pointer', height: 36, width: 36, borderRadius: 18, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 1 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 1) == 'positive' ? '#3AB549' : getResponse(item.ID, 1) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>M</text>
                                        </div>
                                        <div onClick={(e) => { if (getDateBox(2)) setObj({ ...obj, id: 2, jobid: item.ID }) }} style={{ opacity: getDateBox(2) ? 1 : 0.7, cursor: 'pointer', height: 36, width: 36, borderRadius: 18, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 2 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 2) == 'positive' ? '#3AB549' : getResponse(item.ID, 2) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>T</text>
                                        </div>
                                        <div onClick={(e) => { if (getDateBox(3)) setObj({ ...obj, id: 3, jobid: item.ID }) }} style={{ opacity: getDateBox(3) ? 1 : 0.7, cursor: 'pointer', height: 36, width: 36, borderRadius: 18, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 3 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 3) == 'positive' ? '#3AB549' : getResponse(item.ID, 3) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>W</text>
                                        </div>
                                        <div onClick={(e) => { if (getDateBox(4)) setObj({ ...obj, id: 4, jobid: item.ID }) }} style={{ opacity: getDateBox(4) ? 1 : 0.7, cursor: 'pointer', height: 36, width: 36, borderRadius: 18, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 4 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 4) == 'positive' ? '#3AB549' : getResponse(item.ID, 4) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>T</text>
                                        </div>
                                        <div onClick={(e) => { if (getDateBox(5)) setObj({ ...obj, id: 5, jobid: item.ID }) }} style={{ opacity: getDateBox(5) ? 1 : 0.7, cursor: 'pointer', height: 36, width: 36, borderRadius: 18, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 5 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 5) == 'positive' ? '#3AB549' : getResponse(item.ID, 5) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>F</text>
                                        </div>
                                        <div onClick={(e) => { if (getDateBox(6)) setObj({ ...obj, id: 6, jobid: item.ID }) }} style={{ opacity: getDateBox(6) ? 1 : 0.7, cursor: 'pointer', height: 36, width: 36, borderRadius: 18, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 6 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 6) == 'positive' ? '#3AB549' : getResponse(item.ID, 6) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>S</text>
                                        </div>
                                        <div onClick={(e) => { if (getDateBox(7)) setObj({ ...obj, id: 7, jobid: item.ID }) }} style={{ opacity: getDateBox(7) ? 1 : 0.7, cursor: 'pointer', height: 36, width: 36, borderRadius: 18, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 7 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 7) == 'positive' ? '#3AB549' : getResponse(item.ID, 7) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>S</text>
                                        </div>
                                    </div>
                                    <div style={{ width: '40%', display: 'flex', backgroundColor: '#1F2327', justifyContent: 'center', alignItems: 'center', height: 45, borderRadius: 4 }}>
                                        <text style={{ color: 'white', fontWeight: '500', fontFamily: 'Roboto' }}>{decrypt(item.text)}</text>
                                    </div>
                                    {(item.show != undefined && item.show) ? <div onClick={() => { setHabitDelete(item) }} style={{ cursor: 'pointer' }}><MdDeleteOutline size={20} color='red' /></div> : <div style={{ width: 20, height: 20 }} />}
                                </div>
                            </div>)}

                        </div>

                        {obj.id != -1 && <div style={{ zIndex: 100, boxShadow: `0px 0px 1px lightgray`, alignSelf: 'center', width: 200, height: 80, marginTop: 150, display: 'flex', flexDirection: 'row', alignItems: 'center', backgroundColor: '#1F2327', borderRadius: 4, justifyContent: 'space-evenly' }}>

                            <div onClick={() => positiveUpdate()} style={{ cursor: 'pointer', width: 40, height: 40 }}>
                                <img src={require('../assets/tick.png')} style={{ width: 38, height: 38 }} />
                            </div>
                            <div onClick={() => negativeUpdate()} style={{ cursor: 'pointer', width: 40, height: 40 }}>
                                <img src={require('../assets/down.png')} style={{ width: 38, height: 38 }} />
                            </div>
                            <div onClick={() => setObj({ ...obj, id: -1, jobid: -1 })} style={{ cursor: 'pointer', marginTop: -30, marginRight: -15 }}>
                                <RxCross2 color='white' size={20} />
                            </div>
                        </div>}


                        <div style={{ marginLeft: 10, width: '97%', display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', height: 60, marginTop: 10, justifyContent: 'space-between' }}>


                        </div>

                    </div>

                    <div style={{ height: height - 200, width: '35%', backgroundColor: '#292e33', alignSelf: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center' }}>
                        <div className='calendar-container'>
                            <Calendar onChange={(e) => select_date(e)} value={date}
                                tileContent={({ date, view }) => {
                                    if (myjournals.find(x => moment(new Date(Number(x.due_date))).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD') && (x.select == undefined || x.select == false))) {
                                        return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)
                                    }
                                    else if ((myjournals.find(x => moment(new Date(Number(x.due_date))).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD') && (x.select !== undefined && x.select == true)))) return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2, borderStyle: 'solid', borderWidth: 2, borderColor: 'white' }}></div>)
                                    else if (moment(new Date(date)).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) {
                                        return (<div style={{ backgroundColor: '#8455F6', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)
                                    }
                                }} />
                        </div>

                        <div style={{ backgroundColor: '#1F2327', width: '90%', alignSelf: 'center', height: 1, marginTop: 10 }} />

                        <div style={{ display: 'flex', width: 340, alignSelf: 'center', flexDirection: 'column', alignItems: 'center', backgroundColor: '#1F2327', height: 350, marginTop: 15 }}>
                            <text style={{ textAlign: 'center', color: '#8c52ff', fontSize: 22, fontWeight: '500', fontFamily: 'Barlow Condensed', marginTop: 15 }}>NAME HABIT TO NAME ON</text>
                            <div style={{ alignSelf: 'center', width: '96%', justifyContent: 'center', display: 'flex', flexDirection: 'column', height: 300, alignItems: 'center' }}>
                                <text style={{ width: 306, alignSelf: 'center', textAlign: 'left', color: 'white', fontSize: 13, fontWeight: '400', fontFamily: 'Barlow Condensed', marginTop: 10 }}>Pick list :</text>
                                <div style={{ marginTop: 10, width: 323, marginLeft: 0 }}>
                                    <Select
                                        components={{ DropdownIndicator: DropdownIndicator }}
                                        onChange={(e) => { { if (e != null) { setCurrHabit(e.id) } } }}
                                        options={habit_all}
                                        placeholder={'Select'}
                                        className="basic-singlehead"
                                        classNamePrefix="select"
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                //  ...baseStyles,
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                textAlign: "left",
                                                fontWeight: '400',
                                                height: 50,
                                                outline: 'none',
                                                fontFamily: 'Roboto',
                                                borderRadius: 4
                                                , fontFamily: 'Barlow Condensed'
                                            }),
                                            singleValue: (baseStyles, state) => ({

                                                ...baseStyles,
                                                ...dot('white')

                                            }),
                                            placeholder: (baseStyles, state) => ({

                                                ...baseStyles,
                                                ...dot('white')

                                            }),
                                            menu: (baseStyles, state) => ({

                                                ...baseStyles,
                                                ...dot1('white')

                                            }),
                                            menuList: (baseStyles, state) => ({

                                                ...baseStyles,
                                                ...dot2('white')

                                            }),
                                        }}
                                        maxMenuHeight={130}
                                        menuShouldScrollIntoView={true}
                                    />

                                </div>
                                <text style={{ textAlign: 'center', color: '#8c52ff', fontSize: 22, fontWeight: '500', fontFamily: 'Barlow Condensed', marginTop: 5, marginBottom: 5 }}>ADD DETAILS</text>
                                <textarea value={habit_text} onChange={(e) => setHabitText(e.currentTarget.value)} placeholder='Add details' style={{ fontFamily: 'Barlow Condensed', fontWeight: '400', fontSize: 18, color: 'white', borderRadius: 4, padding: 4, width: 295, alignSelf: 'center', height: 115, borderStyle: 'none', outline: 'none', backgroundColor: '#292e33' }} />

                                <div style={{ width: 300, alignSelf: 'center', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: 10, height: 48 }}>
                                    <div style={{ backgroundColor: '#363a3f', width: 120, display: 'flex', alignItems: 'center', flexDirection: 'row', height: 45, justifyContent: 'space-between', borderRadius: 4 }}>
                                        <text style={{ fontWeight: '400', fontSize: 12, color: 'white', fontFamily: 'Roboto', marginLeft: 10 }}>Private ?</text>
                                        <div style={{ width: 45, display: 'flex', marginRight: 10 }}>
                                            <ToggleButton
                                                value={false}
                                                inactiveLabel={<text></text>}
                                                activeLabel={<text></text>}
                                                style={{ background_color: '#41A4C3' }}
                                                onToggle={(value) => {
                                                    // setCompleted(!completed)
                                                }}
                                                colors={{
                                                    activeThumb: {
                                                        base: 'white',
                                                    },
                                                    inactiveThumb: {
                                                        base: '#363a3f',
                                                    },
                                                    active: {
                                                        base: '#8455f6',
                                                        hover: 'rgb(177, 191, 215)',
                                                    },
                                                    inactive: {
                                                        base: '#1f2327',
                                                        hover: 'rgb(95,96,98)',
                                                    }
                                                }} />
                                        </div>
                                    </div>

                                    <div onClick={() => { addHabit() }} style={{ cursor: 'pointer', backgroundColor: '#8455F6', width: 80, display: 'flex', alignItems: 'center', flexDirection: 'row', height: 40, justifyContent: 'space-evenly', borderRadius: 4 }}>
                                        <FiPlus color='white' />
                                        <text style={{ fontWeight: '400', fontSize: 15, color: 'white', fontFamily: 'Roboto', marginLeft: 10 }}>Add</text>
                                    </div>

                                </div>

                            </div>
                        </div>


                    </div>
                </div>

            </div>


            <ReactModal
                isOpen={habit_delete != false}
                contentLabel="Inline Styles Modal Example"
                style={{
                    overlay: {
                        backgroundColor: 'transparent',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    },
                    content: {
                        color: 'lightsteelblue',
                        width: 400,
                        alignSelf: 'center',
                        justifyContent: 'center',
                        height: 200,
                        marginLeft: (window.innerWidth - 600) / 2,
                        backgroundColor: '#131517',
                        display: 'flex'
                    }
                }}
            >

                {habit_delete != false ? <div style={{ alignSelf: 'center', justifyContent: 'center', alignItems: 'center', width: 400, alignContent: 'center', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', backgroundColor: '#1F2327', justifyContent: 'center', alignItems: 'center', height: 45, borderRadius: 4, padding: 4 }}>
                        <text style={{ color: 'white', fontWeight: '500', fontFamily: 'Roboto' }}>{decrypt(habit_delete.text)}</text>
                    </div>
                    <div style={{ alignSelf: 'center', alignItems: 'center', justifyContent: 'center', marginTop: 20 }}>
                        <text style={{ textAlign: 'center', fontFamily: 'Roboto', fontWeight: '500', fontSize: 20, color: 'white' }}>  Are you sure you want to delete this ?</text>
                    </div>
                    <div style={{ marginTop: 20, alignSelf: 'center', justifyContent: 'space-around', flexDirection: 'row', display: 'flex', width: 280, alignItems: 'center' }}>

                        <div onClick={() => delete_habit(habit_delete.ID)} style={{ cursor: 'pointer', width: 75, padding: 10, backgroundColor: 'red', borderRadius: 10, alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                            <text style={{ color: 'white', textAlign: 'center' }}>Yes</text>
                        </div>

                        <div onClick={() => setHabitDelete(false)} style={{ cursor: 'pointer', width: 75, padding: 10, backgroundColor: "#8455f6", borderRadius: 10, alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                            <text style={{ color: 'white', textAlign: 'center' }}>No</text>
                        </div>

                    </div>
                </div> : null}

            </ReactModal>

            <wc-toast></wc-toast>


        </div> : <div style={{ backgroundColor: '#f3f9eb', display: 'flex', flexDirection: 'row', width: width, height: height, position: 'absolute', top: 0, left: 0 }}>


            <input id="actual" ref={ref} accept="/*" type="file" onChange={handleDrop} onClick={(event) => {
                event.currentTarget.value = null
            }} hidden={true} />

            <div style={{ display: 'flex', flexDirection: 'column', width: width, height: getHeight, backgroundColor: '#1f2327' }}>

                <div style={{ display: 'flex', height: 150, width: width, justifyContent: 'space-between', alignItems: 'center', backgroundColor: '#292e33', boxShadow: '1px 1px 1px 1px #292E33' }}>

                    <Popup
                        trigger={<div className="menu-item"><VscThreeBars color='white' size={35} style={{ marginLeft: 25 }} /></div>}
                        position="right top"
                        on="click"
                        closeOnDocumentClick={false}
                        mouseLeaveDelay={300}
                        mouseEnterDelay={30}
                        onOpen={() => setting_ref.current?.scrollIntoView({ behavior: 'smooth' })}
                        contentStyle={{ padding: '0px', border: 'none', marginRight: 50, width: 280, display: 'flex', borderStyle: 'solid', borderWidth: 1, borderColor: 'white' }}
                        arrow={true}
                        overlayStyle={{ marginLeft: -20 }}
                    >
                        <div style={{ backgroundColor: '#8455f6', display: 'flex', flexDirection: 'column', height: 500, width: 280, textAlign: 'center', overflowY: 'scroll' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', backgroundColor: "#8455f6", width: 276, height: 100, justifyContent: 'center', alignItems: 'center' }}>
                                <text style={{ color: 'white', marginTop: 30, fontSize: 15, fontFamily: 'Roboto' }}>{items.myid != null&&decrypt(items.myid.first)} {items.myid != null&&decrypt(items.myid.second)}</text>
                            </div>

                            <div onClick={() => navigate('/Dashboard')} style={{ height: 48, cursor: 'pointer', marginTop: 20, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 286, padding: 10, alignSelf: 'center', alignItems: 'center' }}>
                                <div style={{ width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 19 }}>{inactive_dashboard_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Dashboard</text>
                                </div>
                            </div>


                            {!items.mode ? <div onClick={() => navigate('/Vision')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_vision_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My vision</text>
                                </div>
                            </div> : null}

                            <div onClick={() => navigate('/Goals')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_goal_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My goals</text>
                                </div>
                            </div>


                            <div onClick={() => navigate('/WeeklyPlan')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_week_plan_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Weekly Action Plan</text>
                                </div>
                            </div>


                            {!items.mode ? <div onClick={() => navigate('/Journal')} style={{ cursor: 'pointer', height: 48, marginTop: 5, display: 'flex', justifyContent: 'center', alignContent: 'center', width: 286, padding: 10, alignSelf: 'center', alignItems: 'center' }}>
                                <div style={{ width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_journal_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Journal</text>
                                </div>
                            </div> : null}

                            <div onClick={() => navigate('/ActivityPlan')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_activityplan_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Activity Plan</text>
                                </div>
                            </div>

                            <div ref={setting_ref} onClick={() => navigate('/Wins')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_win_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>My Wins</text>
                                </div>
                            </div>

                            <div onClick={() => navigate('/')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ backgroundColor: '#FFFFFF', flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 19 }}>{active_habit_icon}</div>
                                    <text style={{ color: '#8455F6', marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Habit Tracking</text>
                                </div>
                            </div>

                            <div onClick={() => navigate('/Videos')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{inactive_video_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Videos</text>
                                </div>
                            </div>

                            <div onClick={() => navigate('/Companies')} style={{ cursor: 'pointer', height: 48, marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{invite_inactive}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Invitations</text>
                                </div>
                            </div>

                            <div onClick={() => navigate('/Settings')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{settings_inactive}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Settings</text>
                                </div>
                            </div>

                            <div onClick={() => navigate('/')} style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center' }}>
                                    <div style={{ color: 'white', fontSize: 23 }}>{logout_icon}</div>
                                    <text style={{ color: inactive_color, marginLeft: 30, fontSize: 15, fontFamily: 'Roboto' }}>Log Out</text>
                                </div>
                            </div>

                            <div style={{ height: 48, cursor: 'pointer', marginTop: 5, display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly', alignContent: 'center', width: 286, padding: 10, backgroundColor: 'transparent', alignSelf: 'center' }}>
                                <div style={{ flexDirection: 'row', width: 210, flexDirection: 'row', display: 'flex', padding: 10, borderRadius: 6, alignItems: 'center', backgroundColor: '#FFFFFF' }}>
                                    <text style={{ color: '#8455F6', marginLeft: 20, fontSize: 15, fontFamily: 'Roboto' }}>Coaching Mode</text>
                                    <div style={{ width: 45, display: 'flex', marginLeft: 10 }}>
                                        <ToggleButton
                                            value={items.mode}
                                            inactiveLabel={<text></text>}
                                            activeLabel={<text></text>}
                                            style={{ background_color: '#41A4C3' }}
                                            onToggle={(value) => {
                                                SwitchMode()
                                            }}
                                            colors={{
                                                activeThumb: {
                                                    base: 'white',
                                                },
                                                inactiveThumb: {
                                                    base: 'black',
                                                },
                                                active: {
                                                    base: '#8455f6',
                                                    hover: 'rgb(177, 191, 215)',
                                                },
                                                inactive: {
                                                    base: 'gray',
                                                    hover: 'gray',
                                                }
                                            }} />
                                    </div>
                                </div>
                            </div>

                            <img src={logo} style={{ width: 80, height: 80, alignSelf: 'center', marginTop: 20 }} />

                        </div>
                    </Popup>

                    <div style={{ display: 'flex', justifyContent: 'flex-start', alignItems: 'content' }}>
                        <text style={{ marginLeft: 40, fontSize: 40, fontWeight: '600', letterSpacing: 1.01, color: '#8c52ff', textAlign: 'left', fontFamily: 'Barlow Condensed' }}>MY HABIT TRACKING</text>
                    </div>
                    {items.myid != null&&items.myid.uri == undefined && <img onClick={() => openFileInput()} style={{ cursor: 'pointer', width: 60, height: 60, borderRadius: 30, marginRight: 30 }} src={'data:image/png;base64,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'} />}
                    {items.myid != null&&items.myid.uri != undefined && <img onClick={() => openFileInput()} src={items.myid.uri} style={{ cursor: 'pointer', height: 60, width: 60, borderRadius: 30, marginRight: 30 }} />}

                </div>

                <div ref={top_ref} style={{ marginTop: 50, height: getHeight - 200, width: width, alignSelf: 'center', flexDirection: 'column', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>

                    <div style={{ height: 900, width: 0.97 * width, backgroundColor: '#292e33', alignSelf: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center' }}>


                        <div style={{ display: 'flex', width: '96%', alignSelf: 'center', justifyContent: 'left', alignItems: 'center', backgroundColor: '#1F2327', height: 50, marginTop: 10 }}>
                            <text style={{ textAlign: 'left', color: '#8c52ff', fontSize: 26, fontWeight: '500', fontFamily: 'Barlow Condensed' }}>{start == null ? 'SELECT WEEK FROM CALENDAR' : `WEEK STARTING ${timing(start)}`}</text>
                        </div>

                        <div style={{ width: '97%', alignSelf: 'center', display: 'flex', flexDirection: 'column', justifyContent: 'center', marginTop: 20, overflowY: 'scroll', overflowX: 'hidden', maxHeight: 700 }}>
                            {myhabits.map((item, id) => <div onMouseEnter={() => make_show(item.ID, true)} onMouseLeave={() => make_show(item.ID, false)} style={{ height: 140, width: '97%', flexDirection: 'column', justifyContent: 'left', marginTop: 10 }}>
                                <div style={{ width: '97%', height: 35, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                    <text style={{ color: '#8c52ff', fontWeight: '500', fontFamily: 'Barlow Condensed', fontSize: 22, marginLeft: 4 }}>{getName(item.ID)} - Streak : {item.streak == undefined ? 0 : item.streak} days</text>
                                </div>
                                <div style={{ width: '97%', height: 125, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'space-evenly' }}>

                                    <div style={{ display: 'flex', width: '90%', alignSelf: 'flex-start', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <div style={{ width: '85%', display: 'flex', backgroundColor: '#1F2327', justifyContent: 'center', alignItems: 'center', height: 45, borderRadius: 4 }}>
                                            <text style={{ color: 'white', fontWeight: '500', fontFamily: 'Roboto' }}>{decrypt(item.text)}</text>
                                        </div>
                                        {(item.show != undefined && item.show) ? <div onClick={() => { setHabitDelete(item) }} style={{ cursor: 'pointer' }}><MdDeleteOutline size={20} color='red' /></div> : <div style={{ width: 20, height: 20 }} />}

                                    </div>


                                    <div style={{ width: '80%', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexDirection: 'row', alignSelf: 'flex-start' }}>
                                        <div onClick={(e) => { if (getDateBox(1)) setObj({ ...obj, id: 1, jobid: item.ID }) }} style={{ opacity: getDateBox(1) ? 1 : 0.7, cursor: 'pointer', height: 32, width: 32, borderRadius: 16, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 1 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 1) == 'positive' ? '#3AB549' : getResponse(item.ID, 1) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>M</text>
                                        </div>
                                        <div onClick={(e) => { if (getDateBox(2)) setObj({ ...obj, id: 2, jobid: item.ID }) }} style={{ opacity: getDateBox(2) ? 1 : 0.7, cursor: 'pointer', height: 32, width: 32, borderRadius: 16, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 2 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 2) == 'positive' ? '#3AB549' : getResponse(item.ID, 2) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>T</text>
                                        </div>
                                        <div onClick={(e) => { if (getDateBox(3)) setObj({ ...obj, id: 3, jobid: item.ID }) }} style={{ opacity: getDateBox(3) ? 1 : 0.7, cursor: 'pointer', height: 32, width: 32, borderRadius: 16, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 3 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 3) == 'positive' ? '#3AB549' : getResponse(item.ID, 3) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>W</text>
                                        </div>
                                        <div onClick={(e) => { if (getDateBox(4)) setObj({ ...obj, id: 4, jobid: item.ID }) }} style={{ opacity: getDateBox(4) ? 1 : 0.7, cursor: 'pointer', height: 32, width: 32, borderRadius: 16, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 4 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 4) == 'positive' ? '#3AB549' : getResponse(item.ID, 4) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>T</text>
                                        </div>
                                        <div onClick={(e) => { if (getDateBox(5)) setObj({ ...obj, id: 5, jobid: item.ID }) }} style={{ opacity: getDateBox(5) ? 1 : 0.7, cursor: 'pointer', height: 32, width: 32, borderRadius: 16, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 5 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 5) == 'positive' ? '#3AB549' : getResponse(item.ID, 5) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>F</text>
                                        </div>
                                        <div onClick={(e) => { if (getDateBox(6)) setObj({ ...obj, id: 6, jobid: item.ID }) }} style={{ opacity: getDateBox(6) ? 1 : 0.7, cursor: 'pointer', height: 32, width: 32, borderRadius: 16, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 6 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 6) == 'positive' ? '#3AB549' : getResponse(item.ID, 6) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>S</text>
                                        </div>
                                        <div onClick={(e) => { if (getDateBox(7)) setObj({ ...obj, id: 7, jobid: item.ID }) }} style={{ opacity: getDateBox(7) ? 1 : 0.7, cursor: 'pointer', height: 32, width: 32, borderRadius: 16, justifyContent: 'center', borderStyle: 'solid', borderWidth: obj.jobid == item.ID && obj.id == 7 ? 1 : 0, borderColor: 'white', alignItems: 'center', backgroundColor: getResponse(item.ID, 7) == 'positive' ? '#3AB549' : getResponse(item.ID, 7) == 'negative' ? '#FF0000' : '#757575', display: 'flex' }}>
                                            <text style={{ fontWeight: '600', color: 'white', fontSize: 15 }}>S</text>
                                        </div>
                                    </div>

                                </div>
                            </div>)}

                        </div>


                        <Modal open={obj.id != -1}
                            onClose={() => setObj({ ...obj, id: -1, jobid: -1 })}
                            center
                            styles={{
                                modal: {
                                    backgroundColor: '#1F2327',
                                },
                                closeButton: { backgroundColor: 'white', borderRadius: 15 }
                            }}
                        >
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', width: 120, marginTop: 50, alignSelf: 'center', justifyContent: 'space-evenly' }}>
                                <div onClick={() => positiveUpdate()} style={{ cursor: 'pointer', width: 40, height: 40 }}>
                                    <img src={require('../assets/tick.png')} style={{ width: 38, height: 38 }} />
                                </div>
                                <div onClick={() => negativeUpdate()} style={{ cursor: 'pointer', width: 40, height: 40 }}>
                                    <img src={require('../assets/down.png')} style={{ width: 38, height: 38 }} />
                                </div>

                            </div>

                        </Modal>


                        <div style={{ width: '97%', display: 'flex', alignSelf: 'center', flexDirection: 'row', alignItems: 'center', height: 60, marginTop: 10, justifyContent: 'space-between' }}>


                        </div>

                    </div>

                    <div style={{ height: 1130, width: 0.97 * width, backgroundColor: '#292e33', alignSelf: 'center', flexDirection: 'column', display: 'flex', alignItems: 'center' }}>
                        <div className='calendar-container'>
                            <Calendar onChange={(e) => select_date(e)} value={date}
                                tileContent={({ date, view }) => {
                                    if (myjournals.find(x => moment(new Date(Number(x.due_date))).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD') && (x.select == undefined || x.select == false))) {
                                        return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)
                                    }
                                    else if ((myjournals.find(x => moment(new Date(Number(x.due_date))).format('YYYY-MM-DD') === moment(new Date(date)).format('YYYY-MM-DD') && (x.select !== undefined && x.select == true)))) return (<div style={{ backgroundColor: '#3AB549', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2, borderStyle: 'solid', borderWidth: 2, borderColor: 'white' }}></div>)
                                    else if (moment(new Date(date)).format('YYYY-MM-DD') == moment(new Date()).format('YYYY-MM-DD')) {
                                        return (<div style={{ backgroundColor: '#8455F6', width: 36, height: 36, display: 'flex', marginTop: -26, borderRadius: 18, marginLeft: -2 }}></div>)
                                    }
                                }} />
                        </div>

                        <div style={{ backgroundColor: '#1F2327', width: '90%', alignSelf: 'center', height: 1, marginTop: 10 }} />

                        <div style={{ display: 'flex', width: 320, alignSelf: 'center', flexDirection: 'column', alignItems: 'center', backgroundColor: '#1F2327', height: 350, marginTop: 15 }}>
                            <text style={{ textAlign: 'center', color: '#8c52ff', fontSize: 22, fontWeight: '500', fontFamily: 'Barlow Condensed', marginTop: 15 }}>NAME HABIT TO NAME ON</text>

                            <div style={{ alignSelf: 'center', width: '96%', justifyContent: 'center', display: 'flex', flexDirection: 'column', height: 300, alignItems: 'center' }}>
                                <text style={{ width: 296, alignSelf: 'center', textAlign: 'left', color: 'white', fontSize: 13, fontWeight: '400', fontFamily: 'Barlow Condensed', marginTop: 10 }}>Pick list :</text>
                                <div style={{ marginTop: 10, width: 296, marginLeft: -20 }}>
                                    <Select
                                        components={{ DropdownIndicator: DropdownIndicator }}
                                        onChange={(e) => { { if (e != null) { setCurrHabit(e.id) } } }}
                                        options={habit_all}
                                        placeholder={'Select'}
                                        className="basic-singleheadsmall"
                                        classNamePrefix="select"
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                //  ...baseStyles,
                                                display: 'flex',
                                                flexDirection: 'row',
                                                alignItems: 'center',
                                                textAlign: "left",
                                                fontWeight: '400',
                                                height: 50,
                                                outline: 'none',
                                                fontFamily: 'Roboto',
                                                borderRadius: 4
                                                , fontFamily: 'Barlow Condensed'
                                            }),
                                            singleValue: (baseStyles, state) => ({

                                                ...baseStyles,
                                                ...dot('white')

                                            }),
                                            placeholder: (baseStyles, state) => ({

                                                ...baseStyles,
                                                ...dot('white')

                                            }),
                                            menu: (baseStyles, state) => ({

                                                ...baseStyles,
                                                ...dot1('white')

                                            }),
                                            menuList: (baseStyles, state) => ({

                                                ...baseStyles,
                                                ...dot2('white')

                                            }),
                                        }}
                                        maxMenuHeight={130}
                                        menuShouldScrollIntoView={true}
                                    />

                                </div>
                                <text style={{ textAlign: 'center', color: '#8c52ff', fontSize: 22, fontWeight: '500', fontFamily: 'Barlow Condensed', marginTop: 5, marginBottom: 5 }}>ADD DETAILS</text>
                                <textarea value={habit_text} onChange={(e) => setHabitText(e.currentTarget.value)} placeholder='Add details' style={{ fontFamily: 'Barlow Condensed', fontWeight: '400', fontSize: 18, color: 'white', borderRadius: 4, padding: 4, width: 285, alignSelf: 'center', height: 115, borderStyle: 'none', outline: 'none', backgroundColor: '#292e33' }} />

                                <div style={{ width: 296, alignSelf: 'center', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', marginTop: 10, height: 48 }}>
                                    <div style={{ backgroundColor: '#363a3f', width: 120, display: 'flex', alignItems: 'center', flexDirection: 'row', height: 45, justifyContent: 'space-between', borderRadius: 4 }}>
                                        <text style={{ fontWeight: '400', fontSize: 12, color: 'white', fontFamily: 'Roboto', marginLeft: 10 }}>Private ?</text>
                                        <div style={{ width: 45, display: 'flex', marginRight: 10 }}>
                                            <ToggleButton
                                                value={false}
                                                inactiveLabel={<text></text>}
                                                activeLabel={<text></text>}
                                                style={{ background_color: '#41A4C3' }}
                                                onToggle={(value) => {
                                                    // setCompleted(!completed)
                                                }}
                                                colors={{
                                                    activeThumb: {
                                                        base: 'white',
                                                    },
                                                    inactiveThumb: {
                                                        base: '#363a3f',
                                                    },
                                                    active: {
                                                        base: '#8455f6',
                                                        hover: 'rgb(177, 191, 215)',
                                                    },
                                                    inactive: {
                                                        base: '#1f2327',
                                                        hover: 'rgb(95,96,98)',
                                                    }
                                                }} />
                                        </div>
                                    </div>

                                    <div onClick={() => { addHabit() }} style={{ cursor: 'pointer', backgroundColor: '#8455F6', width: 80, display: 'flex', alignItems: 'center', flexDirection: 'row', height: 40, justifyContent: 'space-evenly', borderRadius: 4 }}>
                                        <FiPlus color='white' />
                                        <text style={{ fontWeight: '400', fontSize: 15, color: 'white', fontFamily: 'Roboto', marginLeft: 10 }}>Add</text>
                                    </div>

                                </div>

                            </div>
                        </div>


                    </div>
                </div>

            </div>


            <ReactModal
                isOpen={habit_delete != false}
                contentLabel="Inline Styles Modal Example"
                style={{
                    overlay: {
                        backgroundColor: 'transparent',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    },
                    content: {
                        color: 'lightsteelblue',
                        width: 400,
                        alignSelf: 'center',
                        justifyContent: 'center',
                        height: 200,
                        marginLeft: (window.innerWidth - 600) / 2,
                        backgroundColor: '#131517',
                        display: 'flex'
                    }
                }}
            >

                {habit_delete != false ? <div style={{ alignSelf: 'center', justifyContent: 'center', alignItems: 'center', width: 400, alignContent: 'center', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ display: 'flex', backgroundColor: '#1F2327', justifyContent: 'center', alignItems: 'center', height: 45, borderRadius: 4, padding: 4 }}>
                        <text style={{ color: 'white', fontWeight: '500', fontFamily: 'Roboto' }}>{decrypt(habit_delete.text)}</text>
                    </div>
                    <div style={{ alignSelf: 'center', alignItems: 'center', justifyContent: 'center', marginTop: 20 }}>
                        <text style={{ textAlign: 'center', fontFamily: 'Roboto', fontWeight: '500', fontSize: 20, color: 'white' }}>  Are you sure you want to delete this ?</text>
                    </div>
                    <div style={{ marginTop: 20, alignSelf: 'center', justifyContent: 'space-around', flexDirection: 'row', display: 'flex', width: 280, alignItems: 'center' }}>

                        <div onClick={() => delete_habit(habit_delete.ID)} style={{ cursor: 'pointer', width: 75, padding: 10, backgroundColor: 'red', borderRadius: 10, alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                            <text style={{ color: 'white', textAlign: 'center' }}>Yes</text>
                        </div>

                        <div onClick={() => setHabitDelete(false)} style={{ cursor: 'pointer', width: 75, padding: 10, backgroundColor: "#8455f6", borderRadius: 10, alignItems: 'center', display: 'flex', justifyContent: 'center' }}>
                            <text style={{ color: 'white', textAlign: 'center' }}>No</text>
                        </div>

                    </div>
                </div> : null}

            </ReactModal>

            <wc-toast></wc-toast>


        </div>
    );
}

const mapStateToProps = state => {
    //  console.log(state)
    return {
        items: state._todoProduct
    }
}

export default connect(mapStateToProps, { SetId, SwitchMode })(Habit)
